import React from 'react'
import SmartNavigator from '../generic/SmartNavigator'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import FabricationOrderAcceptanceListContainer from '../fabricationOrderAcceptance/FabricationOrderAcceptanceListContainer'

// RN4/RN7/CA8 — Product Acceptance (MOD) now lives at its own route (/quality/productAcceptance,
// D3) instead of the former "Fabrication order acceptance" tab inside Quality. The screen itself
// (FabricationOrderAcceptanceListContainer) is unchanged: this route only relocates where it is
// reached from, it does not alter its content or behaviour. Like every other single-screen route,
// it is wrapped in SmartNavigator so the window title shows as a tab in the header.
const MainQualityProductAcceptance = () => {
  const { t_ } = useSmartTranslation()
  const componentsInfo = [
    {
      title: t_('Product Acceptance (MOD)'),
      component: <FabricationOrderAcceptanceListContainer />
    }
  ]
  return (
    <div>
      <SmartNavigator componentsInfo={componentsInfo} />
    </div>
  )
}

export default MainQualityProductAcceptance
